import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { UpdateWorkspaceTimeZoneModal } from '../components/UpdateWorkspaceTimeZoneModal';
import { IUpdateWorkspaceTimeZoneBl } from '../UpdateWorkspaceTimeZone.bl';
import { IUpdateWorkspaceTimeZoneStore } from '../UpdateWorkspaceTimeZone.store';

export const UpdateWorkspaceTimeZoneModalContainer = observer((): ReactElement => {
  const store = useInjection(IUpdateWorkspaceTimeZoneStore.$);
  const bl = useInjection(IUpdateWorkspaceTimeZoneBl.$);

  const handleHideModal = (): void => {
    bl.hideForm();
  };

  return (
    <UpdateWorkspaceTimeZoneModal
      onHideModal={handleHideModal}
      showModal={store.showModal}
    />
  );
});
